/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'viewpResp.trafficState.@trafficModelId') || -1;
    };
});



// WEBPACK FOOTER //
// ./model/traffic/trafficModelId.js